import { render, staticRenderFns } from "./oldOrderCreate.vue?vue&type=template&id=87d9dd14&scoped=true"
import script from "./oldOrderCreate.vue?vue&type=script&lang=js"
export * from "./oldOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./oldOrderCreate.vue?vue&type=style&index=0&id=87d9dd14&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d9dd14",
  null
  
)

export default component.exports